
export default {
  state: {
    wulinShareParams: {}
  },
  mutations: {
    setWulinShareParams(state, params) {
      state.wulinShareParams = params
    }
  },

  actions: {
    
  },
}